// import React, { useState, useEffect } from "react";
// import "../../../css/ConfigureStationModal.css";
// import api from "../../../api/axiosConfig";
// import AddStationSubModal, { AssignedStation } from "./AddStationSubModal";
// import { showToast } from '../../Shared/Toaster';

// interface ConfigureStationModalProps {
//   station: {
//     appointmentId: string;
//     centerId: string;
//     centerName: string;
//     city: string;
//     startDate: string;
//     endDate: string;
//     slotDesigns: Record<string, string>;
//   };
//   onClose: () => void;
// }

// interface ParsedConflict {
//   userName: string;
//   centerName: string;
//   slots: { date: string; time: string }[];
// }

// const ConfigureStationModal: React.FC<ConfigureStationModalProps> = ({ station, onClose }) => {
//   const [assignedStations, setAssignedStations] = useState<AssignedStation[]>([]);
//   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [stationToEdit, setStationToEdit] = useState<AssignedStation | null>(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isLoadingConfig, setIsLoadingConfig] = useState(false);
//   const [conflictMessage, setConflictMessage] = useState<string | null>(null);
//   const [conflictDetails, setConflictDetails] = useState<ParsedConflict[] | null>(null);
//   const [configExists, setConfigExists] = useState(false);

//   // Fetch existing center configuration
//   useEffect(() => {
//     const fetchConfig = async () => {
//       setIsLoadingConfig(true);
//       try {
//         const token = sessionStorage.getItem("accessToken");

//         // Fetch config and staff list in parallel
//         const configPromise = api.center_api.get(`/api/v1/center/${station.centerId}/config`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         const staffPromise = api.auth_api.get<any[]>("/users/with-roles/full", {
//           headers: { Authorization: `Bearer ${token}` },
//         });

//         const [res, staffRes] = await Promise.all([configPromise, staffPromise]);
//         const staffList = staffRes.data || [];

//         if (res.data?.success && res.data.data) {
//           setConfigExists(true);
//           const config = res.data.data;
//           const flattened: AssignedStation[] = [];
//           config.stations.forEach((s: any) => {
//             s.users.forEach((u: any) => {
//               // Find the user in the full staff list by either _id or entraObjectId
//               const userDetail = staffList.find((staff: any) => staff._id === u.userId || staff.entraObjectId === u.userId);

//               flattened.push({
//                 id: `${s.stationId}-${u.userId}-${Math.random()}`, // Local unique ID
//                 stationId: s.stationId,
//                 stationName: s.stationName,
//                 staffId: userDetail?._id || u.userId,
//                 staffName: u.userName,
//                 oid: userDetail?.entraObjectId || u.userId || "", // Map to entraObjectId if found
//               });
//             });
//           });
//           setAssignedStations(flattened);
//         }
//       } catch (err) {
//         console.error("Failed to fetch existing configuration:", err);
//       } finally {
//         setIsLoadingConfig(false);
//       }
//     };

//     fetchConfig();
//   }, [station.centerId]);

//   const handleConfigureAndNotify = async () => {
//     if (assignedStations.length === 0) {
//       showToast("Please add at least one station and staff assignment.", 'error');
//       return;
//     }

//     setIsSubmitting(true);

//     const groupedByStation = assignedStations.reduce((acc, current) => {
//       let group = acc.find(g => g.stationId === current.stationId);
//       if (!group) {
//         group = {
//           stationId: current.stationId,
//           stationName: current.stationName,
//           users: [],
//         };
//         acc.push(group);
//       }
//       group.users.push({
//         userId: current.oid,
//         userName: current.staffName,
//       });
//       return acc;
//     }, [] as any[]);

//     const payload = {
//       centerId: station.centerId,
//       centerName: station.centerName,
//       appointmentClusterId: station.appointmentId,
//       stations: groupedByStation,
//       status: "Configured",
//     };

//     try {
//       const token = sessionStorage.getItem("accessToken");

//       if (configExists) {
//         const patchPayload = {
//           centerName: station.centerName,
//           stations: groupedByStation,
//         };
//         await api.center_api.patch(`/api/v1/center/${station.centerId}/config`, patchPayload, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//       } else {
//         await api.center_api.post("/api/v1/center/config", payload, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//       }

//       showToast("Center configured successfully!", 'success');
//       onClose();
//     } catch (error: any) {
//       console.error("Failed to configure center:", error);
//       const data = error.response?.data;
//       if (data) {
//         if (data.conflicts && Array.isArray(data.conflicts)) {
//           const parsedConflicts: ParsedConflict[] = [];
//           const conflictStrings: string[] = [];

//           data.conflicts.forEach((userConflict: any) => {
//             if (userConflict.userName && Array.isArray(userConflict.conflicts)) {
//               const centerSlotsMap = new Map<string, Set<string>>();

//               userConflict.conflicts.forEach((c: any) => {
//                 if (c.centerName && Array.isArray(c.slots)) {
//                   if (!centerSlotsMap.has(c.centerName)) {
//                     centerSlotsMap.set(c.centerName, new Set());
//                   }
//                   const slotsSet = centerSlotsMap.get(c.centerName)!;
//                   c.slots.forEach((s: any) => {
//                     slotsSet.add(JSON.stringify({ date: s.date, time: `${s.startTime} - ${s.endTime}` }));
//                   });
//                 }
//               });

//               centerSlotsMap.forEach((slotsSet, centerName) => {
//                 parsedConflicts.push({
//                   userName: userConflict.userName,
//                   centerName: centerName,
//                   slots: Array.from(slotsSet).map(str => JSON.parse(str))
//                 });
//               });
//             } else if (typeof userConflict === 'string') {
//               conflictStrings.push(userConflict);
//             }
//           });

//           if (parsedConflicts.length > 0) {
//             setConflictDetails(parsedConflicts);
//             setConflictMessage(conflictStrings.length > 0 ? conflictStrings.join('\n') : null);
//           } else {
//             setConflictMessage(conflictStrings.length > 0 ? conflictStrings.join('\n') : "User assignment conflicts detected.");
//           }
//         } else if (data.details && Array.isArray(data.details)) {
//           setConflictMessage(data.details.join('\n'));
//         } else if (data.error) {
//           setConflictMessage(typeof data.error === 'string' ? data.error : JSON.stringify(data.error));
//         } else if (data.message) {
//           setConflictMessage(typeof data.message === 'string' ? data.message : JSON.stringify(data.message));
//         } else {
//           showToast("An error occurred while saving the configuration. Please try again.", 'error');
//         }
//       } else {
//         showToast("An error occurred while saving the configuration. Please try again.", 'error');
//       }
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleSaveStation = (data: AssignedStation) => {
//     if (stationToEdit) {
//       setAssignedStations(prev => prev.map(item => (item.id === stationToEdit.id ? data : item)));
//     } else {
//       setAssignedStations(prev => [...prev, data]);
//     }
//     setIsAddModalOpen(false);
//   };

//   const handleDeleteStation = (stationToDelete: AssignedStation) => {
//     if (!window.confirm(`Are you sure you want to remove ${stationToDelete.staffName} from ${stationToDelete.stationName}?`)) {
//       return;
//     }

//     setAssignedStations(prevStations => prevStations.filter(item => item.id !== stationToDelete.id));
//     showToast("Assignment removed from list.", 'success');
//   };

//   const openEditModal = (station: AssignedStation) => {
//     setStationToEdit(station);
//     setIsAddModalOpen(true);
//   };

//   const openAddModal = () => {
//     setStationToEdit(null);
//     setIsAddModalOpen(true);
//   };

//   const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
//   const slotTemplateData = daysOfWeek.map(day => ({
//     day,
//     template: station.slotDesigns?.[day] || "None",
//   }));

//   return (
//     <>
//       <div className="modal-overlay" onClick={onClose}>
//         <div className="modal-content-configure-station" onClick={(e) => e.stopPropagation()}>
//           <h2 className="modal-header">Configure Station & Staff</h2>

//           <div className="station-details-grid">
//             <div className="detail-item"><span className="label">Center Name</span><span className="value">{station.centerName}</span></div>
//             <div className="detail-item"><span className="label">City</span><span className="value">{station.city}</span></div>
//             <div className="detail-item"><span className="label">Start Date</span><span className="value">{station.startDate}</span></div>
//             <div className="detail-item"><span className="label">End Date</span><span className="value">{station.endDate}</span></div>
//           </div>
//           <h3 className="section-title">Slot Template</h3>
//           <table className="slot-template-table">
//             <thead><tr><th>Day</th><th>Slot Template</th></tr></thead>
//             <tbody>
//               {slotTemplateData.map((slot, index) => <tr key={index}><td>{slot.day}</td><td>{slot.template}</td></tr>)}
//             </tbody>
//           </table>

//           <h3 className="section-title">Stations & Staff Assignment</h3>
//           <table className="staff-assignment-table">
//             <thead><tr><th>STATION</th><th>ASSIGNED STAFF</th><th>Actions</th></tr></thead>
//             <tbody>
//               {isLoadingConfig ? (
//                 <tr><td colSpan={3} style={{ textAlign: 'center', color: '#888' }}>Loading configuration...</td></tr>
//               ) : assignedStations.length === 0 ? (
//                 <tr><td colSpan={3} style={{ textAlign: 'center', color: '#888' }}>No stations have been added.</td></tr>
//               ) : (
//                 assignedStations.map(item => (
//                   <tr key={item.id}>
//                     <td>{item.stationName}</td>
//                     <td>{item.staffName}</td>
//                     <td className="actions-cell">
//                       <svg onClick={() => openEditModal(item)} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="action-icon"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
//                       <svg onClick={() => handleDeleteStation(item)} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="action-icon icon-delete"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>

//           <p className="add-station-link" onClick={openAddModal}>+ Add Station</p>

//           <div className="modal-actions">
//             <button onClick={onClose} className="btn-secondary" disabled={isSubmitting}>
//               Close
//             </button>
//             <button onClick={handleConfigureAndNotify} className="btn-primary" disabled={isSubmitting}>
//               {isSubmitting ? "Submitting..." : "Configure & Notify Staff"}
//             </button>
//           </div>
//         </div>
//       </div>

//       {isAddModalOpen && (
//         <AddStationSubModal
//           onClose={() => setIsAddModalOpen(false)}
//           onSave={handleSaveStation}
//           editData={stationToEdit}
//           centerId={station.centerId}
//           centerName={station.centerName}
//         />
//       )}

//       {(conflictMessage || conflictDetails) && (
//         <div className="modal-overlay" style={{ zIndex: 1000 }}>
//           <div className="modal-content" style={{ maxWidth: conflictDetails ? '600px' : '450px', maxHeight: '85vh', display: 'flex', flexDirection: 'column', padding: '24px', textAlign: 'center' }}>
//             <div style={{ marginBottom: '16px', flexShrink: 0 }}>
//               <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <circle cx="12" cy="12" r="10"></circle>
//                 <line x1="12" y1="8" x2="12" y2="12"></line>
//                 <line x1="12" y1="16" x2="12.01" y2="16"></line>
//               </svg>
//             </div>
//             <h3 style={{ color: '#e74c3c', marginBottom: '16px', fontSize: '1.25rem', flexShrink: 0 }}>Assignment Conflict</h3>

//             <div style={{ overflowY: 'auto', textAlign: 'left', marginBottom: '24px', flexGrow: 1, padding: '0 8px' }}>
//               {conflictMessage && (
//                 <p style={{ whiteSpace: 'pre-wrap', color: '#555', lineHeight: '1.5', margin: '0 0 16px 0' }}>
//                   {conflictMessage}
//                 </p>
//               )}
//               {conflictDetails && (
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
//                   {conflictDetails.map((conflict, idx) => (
//                     <div key={idx} style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', padding: '16px' }}>
//                       <p style={{ margin: '0 0 12px 0', fontWeight: '600', color: '#b91c1c' }}>
//                         {conflict.userName} <span style={{ fontWeight: '400', color: '#7f1d1d' }}>is already assigned to</span> {conflict.centerName}
//                       </p>
//                       <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '8px' }}>
//                         {conflict.slots.map((slot, sIdx) => (
//                           <div key={sIdx} style={{ background: 'white', border: '1px solid #f87171', borderRadius: '4px', padding: '6px 8px', fontSize: '0.8rem', color: '#991b1b', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                             <span style={{ fontWeight: 'bold' }}>{slot.date}</span>
//                             <span>{slot.time}</span>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>

//             <div className="modal-actions" style={{ justifyContent: 'center', flexShrink: 0 }}>
//               <button onClick={() => { setConflictMessage(null); setConflictDetails(null); }} className="btn-primary" style={{ minWidth: '120px' }}>Okay</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ConfigureStationModal;

import React, { useState, useEffect } from "react";
import "../../../css/ConfigureStationModal.css";
import api from "../../../api/axiosConfig";
import AddStationSubModal, { AssignedStation } from "./AddStationSubModal";
import { showToast } from "../../Shared/Toaster";

interface ConfigureStationModalProps {
  station: {
    appointmentId: string;
    centerId: string;
    centerName: string;
    centerType?: string;
    city: string;
    startDate: string;
    endDate: string;
    slotDesigns: Record<string, string>;
  };
  onClose: () => void;
  onSuccess?: () => void;
}

interface ParsedConflict {
  userName: string;
  centerName: string;
  slots: { date: string; time: string }[];
}

const ConfigureStationModal: React.FC<ConfigureStationModalProps> = ({
  station,
  onClose,
  onSuccess,
}) => {
  const [assignedStations, setAssignedStations] = useState<AssignedStation[]>(
    [],
  );
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [stationToEdit, setStationToEdit] = useState<AssignedStation | null>(
    null,
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingConfig, setIsLoadingConfig] = useState(false);
  const [conflictMessage, setConflictMessage] = useState<string | null>(null);
  const [conflictDetails, setConflictDetails] = useState<
    ParsedConflict[] | null
  >(null);
  const [configExists, setConfigExists] = useState(false);

  const isCampCenter =
    Boolean(
      station.centerType && station.centerType.toUpperCase().includes("CAMP"),
    ) ||
    Boolean(
      station.centerName && station.centerName.toUpperCase().includes("CAMP"),
    );

  const getDayAndDate = (dateKey: string) => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateKey)) {
      const [yyyy, mm, dd] = dateKey.split("-");
      const d = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
      const dayName = isNaN(d.getTime())
        ? dateKey
        : d.toLocaleDateString("en-US", { weekday: "long" });
      const formattedDate = `${dd}-${mm}-${yyyy}`;
      return { day: dayName, date: formattedDate };
    }

    if (/^\d{2}-\d{2}-\d{4}$/.test(dateKey)) {
      const [dd, mm, yyyy] = dateKey.split("-");
      const d = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
      const dayName = isNaN(d.getTime())
        ? dateKey
        : d.toLocaleDateString("en-US", { weekday: "long" });
      return { day: dayName, date: dateKey };
    }

    if (station.startDate) {
      const parseDateStr = (str: string) => {
        const parts = str.split("-");
        if (parts.length !== 3) return null;
        if (parts[0].length === 4) {
          return new Date(
            parseInt(parts[0]),
            parseInt(parts[1]) - 1,
            parseInt(parts[2]),
          );
        }
        return new Date(
          parseInt(parts[2]),
          parseInt(parts[1]) - 1,
          parseInt(parts[0]),
        );
      };

      const start = parseDateStr(station.startDate);
      const end = station.endDate ? parseDateStr(station.endDate) : start;

      if (start && !isNaN(start.getTime())) {
        const curr = new Date(start);
        const maxEnd = end && !isNaN(end.getTime()) ? end : start;

        while (curr <= maxEnd) {
          const currDay = curr.toLocaleDateString("en-US", { weekday: "long" });
          if (currDay.toLowerCase() === dateKey.toLowerCase()) {
            const dd = String(curr.getDate()).padStart(2, "0");
            const mm = String(curr.getMonth() + 1).padStart(2, "0");
            const yyyy = curr.getFullYear();
            return { day: currDay, date: `${dd}-${mm}-${yyyy}` };
          }
          curr.setDate(curr.getDate() + 1);
        }

        const dd = String(start.getDate()).padStart(2, "0");
        const mm = String(start.getMonth() + 1).padStart(2, "0");
        const yyyy = start.getFullYear();
        return { day: dateKey, date: `${dd}-${mm}-${yyyy}` };
      }
    }

    return { day: dateKey, date: station.startDate || "—" };
  };

  // Fetch existing configuration tied to this center and this exact cluster combo
  useEffect(() => {
    const fetchConfig = async () => {
      setIsLoadingConfig(true);
      try {
        const token = sessionStorage.getItem("accessToken");

        const configPromise = api.center_api.get(
          `/api/v1/center/${station.centerId}/config?appointmentClusterId=${station.appointmentId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        const staffPromise = api.auth_api.get<any[]>("/users/with-roles/full", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const [res, staffRes] = await Promise.all([
          configPromise,
          staffPromise,
        ]);
        const staffList = staffRes.data || [];

        if (
          res.data?.success &&
          res.data.data &&
          res.data.data.appointmentClusterId === station.appointmentId
        ) {
          setConfigExists(true);
          const config = res.data.data;
          const flattened: AssignedStation[] = [];
          config.stations.forEach((s: any) => {
            s.users.forEach((u: any) => {
              const userDetail = staffList.find(
                (staff: any) =>
                  staff._id === u.userId || staff.entraObjectId === u.userId,
              );

              flattened.push({
                id: `${s.stationId}-${u.userId}-${Math.random()}`,
                stationId: s.stationId,
                stationName: s.stationName,
                staffId: userDetail?._id || u.userId,
                staffName: u.userName,
                oid: userDetail?.entraObjectId || u.userId || "",
              });
            });
          });
          setAssignedStations(flattened);
        } else {
          setConfigExists(false);
          setAssignedStations([]);
        }
      } catch (err) {
        console.error("Failed to fetch existing configuration:", err);
        setConfigExists(false);
        setAssignedStations([]);
      } finally {
        setIsLoadingConfig(false);
      }
    };

    fetchConfig();
  }, [station.centerId, station.appointmentId]);

  const handleConfigureAndNotify = async () => {
    if (assignedStations.length <= 5) {
      showToast("Please add All Six station and staff assignment.", "error");
      return;
    }

    setIsSubmitting(true);

    const groupedByStation = assignedStations.reduce((acc, current) => {
      let group = acc.find((g) => g.stationId === current.stationId);
      if (!group) {
        group = {
          stationId: current.stationId,
          stationName: current.stationName,
          users: [],
        };
        acc.push(group);
      }
      group.users.push({
        userId: current.oid,
        userName: current.staffName,
        email: current.email,
      });
      return acc;
    }, [] as any[]);

    const payload = {
      centerId: station.centerId,
      centerName: station.centerName,
      appointmentClusterId: station.appointmentId,
      stations: groupedByStation,
      status: "Configured",
    };

    try {
      const token = sessionStorage.getItem("accessToken");

      if (configExists) {
        const patchPayload = {
          centerName: station.centerName,
          stations: groupedByStation,
          appointmentClusterId: station.appointmentId,
        };

        await api.center_api.patch(
          `/api/v1/center/${station.centerId}/config?appointmentClusterId=${station.appointmentId}`,
          patchPayload,
          { headers: { Authorization: `Bearer ${token}` } },
        );
      } else {
        await api.center_api.post("/api/v1/center/config", payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      showToast("Center configured successfully!", "success");
      if (onSuccess) onSuccess();
      onClose();
    } catch (error: any) {
      console.error("Failed to configure center:", error);
      const data = error.response?.data;
      if (data) {
        if (data.conflicts && Array.isArray(data.conflicts)) {
          const parsedConflicts: ParsedConflict[] = [];
          const conflictStrings: string[] = [];

          data.conflicts.forEach((userConflict: any) => {
            if (
              userConflict.userName &&
              Array.isArray(userConflict.conflicts)
            ) {
              const centerSlotsMap = new Map<string, Set<string>>();

              userConflict.conflicts.forEach((c: any) => {
                if (c.centerName && Array.isArray(c.slots)) {
                  if (!centerSlotsMap.has(c.centerName)) {
                    centerSlotsMap.set(c.centerName, new Set());
                  }
                  const slotsSet = centerSlotsMap.get(c.centerName)!;
                  c.slots.forEach((s: any) => {
                    slotsSet.add(
                      JSON.stringify({
                        date: s.date,
                        time: `${s.startTime} - ${s.endTime}`,
                      }),
                    );
                  });
                }
              });

              centerSlotsMap.forEach((slotsSet, centerName) => {
                parsedConflicts.push({
                  userName: userConflict.userName,
                  centerName: centerName,
                  slots: Array.from(slotsSet).map((str) => JSON.parse(str)),
                });
              });
            } else if (typeof userConflict === "string") {
              conflictStrings.push(userConflict);
            }
          });

          if (parsedConflicts.length > 0) {
            setConflictDetails(parsedConflicts);
            setConflictMessage(
              conflictStrings.length > 0 ? conflictStrings.join("\n") : null,
            );
          } else {
            setConflictMessage(
              conflictStrings.length > 0
                ? conflictStrings.join("\n")
                : "User assignment conflicts detected.",
            );
          }
        } else if (data.details && Array.isArray(data.details)) {
          setConflictMessage(data.details.join("\n"));
        } else if (data.error) {
          setConflictMessage(
            typeof data.error === "string"
              ? data.error
              : JSON.stringify(data.error),
          );
        } else if (data.message) {
          setConflictMessage(
            typeof data.message === "string"
              ? data.message
              : JSON.stringify(data.message),
          );
        } else {
          showToast(
            "An error occurred while saving the configuration. Please try again.",
            "error",
          );
        }
      } else {
        showToast(
          "An error occurred while saving the configuration. Please try again.",
          "error",
        );
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSaveStation = (data: AssignedStation) => {
    if (stationToEdit) {
      setAssignedStations((prev) =>
        prev.map((item) => (item.id === stationToEdit.id ? data : item)),
      );
    } else {
      setAssignedStations((prev) => [...prev, data]);
    }
    setIsAddModalOpen(false);
  };

  const handleDeleteStation = (stationToDelete: AssignedStation) => {
    if (
      !window.confirm(
        `Are you sure you want to remove ${stationToDelete.staffName} from ${stationToDelete.stationName}?`,
      )
    ) {
      return;
    }

    setAssignedStations((prevStations) =>
      prevStations.filter((item) => item.id !== stationToDelete.id),
    );
    showToast("Assignment removed from list.", "success");
  };

  const openEditModal = (station: AssignedStation) => {
    setStationToEdit(station);
    setIsAddModalOpen(true);
  };

  const openAddModal = () => {
    setStationToEdit(null);
    setIsAddModalOpen(true);
  };

  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const getActiveSlotTemplates = () => {
    if (!station.slotDesigns) return [];

    const isNone = (val: any) => {
      if (!val) return true;
      const t = String(val).trim().toLowerCase();
      return t === "" || t === "none" || t === "null" || t === "undefined";
    };

    const entries = Object.entries(station.slotDesigns);
    const activeEntries = entries.filter(([_, template]) => !isNone(template));

    if (activeEntries.length > 0) {
      return activeEntries.map(([dayOrDate, template]) => ({
        day: dayOrDate,
        template: String(template),
      }));
    }

    return daysOfWeek
      .map((day) => ({
        day,
        template: station.slotDesigns?.[day] || "None",
      }))
      .filter((slot) => !isNone(slot.template));
  };

  const slotTemplateData = getActiveSlotTemplates();

  return (
    <>
      <div className="modal-overlay" onClick={onClose}>
        <div
          className="modal-content-configure-station"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header-config">
            <h2 className="modal-header-config-title">
              Configure Station & Staff
            </h2>
            <button className="global-close-btn" onClick={onClose}>
              ✕
            </button>
          </div>

          <div className="station-details-grid">
            <div className="detail-item">
              <span className="label">Center Name</span>
              <span className="value">{station.centerName}</span>
            </div>
            <div className="detail-item">
              <span className="label">City</span>
              <span className="value">{station.city}</span>
            </div>
            <div className="detail-item">
              <span className="label">Start Date</span>
              <span className="value">{station.startDate}</span>
            </div>
            <div className="detail-item">
              <span className="label">End Date</span>
              <span className="value">{station.endDate}</span>
            </div>
          </div>
          <h3 className="section-title-config">Slot Template</h3>
          <table className="slot-template-table">
            <thead>
              <tr>
                <th>Day</th>
                {isCampCenter && <th>Date</th>}
                <th>Slot Template</th>
              </tr>
            </thead>
            <tbody>
              {slotTemplateData.length > 0 ? (
                slotTemplateData.map((slot, index) => {
                  if (isCampCenter) {
                    const { day, date } = getDayAndDate(slot.day);
                    return (
                      <tr key={index}>
                        <td>{day}</td>
                        <td>{date}</td>
                        <td>{slot.template}</td>
                      </tr>
                    );
                  }
                  return (
                    <tr key={index}>
                      <td>{slot.day}</td>
                      <td>{slot.template}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={isCampCenter ? 3 : 2}
                    style={{
                      textAlign: "center",
                      color: "#888",
                      padding: "12px",
                    }}
                  >
                    No active slot templates assigned.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <h3 className="section-title-config">Stations & Staff Assignment</h3>
          <table className="staff-assignment-table">
            <thead>
              <tr>
                <th>STATION</th>
                <th>ASSIGNED STAFF</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {isLoadingConfig ? (
                <tr>
                  <td
                    colSpan={3}
                    style={{ textAlign: "center", color: "#888" }}
                  >
                    Loading configuration...
                  </td>
                </tr>
              ) : assignedStations.length === 0 ? (
                <tr>
                  <td
                    colSpan={3}
                    style={{ textAlign: "center", color: "#888" }}
                  >
                    No stations have been added.
                  </td>
                </tr>
              ) : (
                assignedStations.map((item) => (
                  <tr key={item.id}>
                    <td>{item.stationName}</td>
                    <td>{item.staffName}</td>
                    <td className="actions-cell">
                      <svg
                        onClick={() => openEditModal(item)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="action-icon"
                      >
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                      </svg>
                      <svg
                        onClick={() => handleDeleteStation(item)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="action-icon icon-delete"
                      >
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                        <line x1="10" y1="11" x2="10" y2="17"></line>
                        <line x1="14" y1="11" x2="14" y2="17"></line>
                      </svg>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <p className="add-station-link" onClick={openAddModal}>
            + Add Station
          </p>

          <div className="modal-actions">
            <button
              onClick={onClose}
              className="btn-secondary"
              disabled={isSubmitting}
            >
              Close
            </button>
            <button
              onClick={handleConfigureAndNotify}
              className="btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Configure & Notify Staff"}
            </button>
          </div>
        </div>
      </div>

      {isAddModalOpen && (
        <AddStationSubModal
          onClose={() => setIsAddModalOpen(false)}
          onSave={handleSaveStation}
          editData={stationToEdit}
          centerId={station.centerId}
          centerName={station.centerName}
        />
      )}

      {(conflictMessage || conflictDetails) && (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
          <div
            className="modal-content"
            style={{
              maxWidth: conflictDetails ? "600px" : "450px",
              maxHeight: "85vh",
              display: "flex",
              flexDirection: "column",
              padding: "24px",
              textAlign: "center",
            }}
          >
            <div style={{ marginBottom: "16px", flexShrink: 0 }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#e74c3c"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <h3
              style={{
                color: "#e74c3c",
                marginBottom: "16px",
                fontSize: "1.25rem",
                flexShrink: 0,
              }}
            >
              Assignment Conflict
            </h3>

            <div
              style={{
                overflowY: "auto",
                textAlign: "left",
                marginBottom: "24px",
                flexGrow: 1,
                padding: "0 8px",
              }}
            >
              {conflictMessage && (
                <p
                  style={{
                    whiteSpace: "pre-wrap",
                    color: "#555",
                    lineHeight: "1.5",
                    margin: "0 0 16px 0",
                  }}
                >
                  {conflictMessage}
                </p>
              )}
              {conflictDetails && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  {conflictDetails.map((conflict, idx) => (
                    <div
                      key={idx}
                      style={{
                        background: "#fef2f2",
                        border: "1px solid #fecaca",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      <p
                        style={{
                          margin: "0 0 12px 0",
                          fontWeight: "600",
                          color: "#b91c1c",
                        }}
                      >
                        {conflict.userName}{" "}
                        <span style={{ fontWeight: "400", color: "#7f1d1d" }}>
                          is already assigned to
                        </span>{" "}
                        {conflict.centerName}
                      </p>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fill, minmax(130px, 1fr))",
                          gap: "8px",
                        }}
                      >
                        {conflict.slots.map((slot, sIdx) => (
                          <div
                            key={sIdx}
                            style={{
                              background: "white",
                              border: "1px solid #f87171",
                              borderRadius: "4px",
                              padding: "6px 8px",
                              fontSize: "0.8rem",
                              color: "#991b1b",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <span style={{ fontWeight: "bold" }}>
                              {slot.date}
                            </span>
                            <span>{slot.time}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div
              className="modal-actions"
              style={{ justifyContent: "center", flexShrink: 0 }}
            >
              <button
                onClick={() => {
                  setConflictMessage(null);
                  setConflictDetails(null);
                }}
                className="btn-primary"
                style={{ minWidth: "120px" }}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConfigureStationModal;
